import { useQuery } from '@tanstack/react-query';

import { browserZone } from '../../shared/lib/format';
import {
  me,
  myOrganizations,
  myPreferences,
  type TMembership,
  type TPreferences,
  type TUser,
} from './api';

/** `timezone` always names a zone: the one picked, else this browser's (`zoneChosen: false`). */
export interface ISessionPreferences extends Omit<TPreferences, 'timezone'> {
  timezone: string;
  zoneChosen: boolean;
}

export interface ISession {
  user: TUser;
  memberships: TMembership[];
  preferences: ISessionPreferences;
}

export const useSession = () =>
  useQuery({
    queryKey: ['session'],
    queryFn: async (): Promise<ISession> => {
      const [user, memberships, preferences] = await Promise.all([
        me(),
        myOrganizations(),
        myPreferences(),
      ]);
      return {
        user,
        memberships,
        preferences: {
          ...preferences,
          timezone: preferences.timezone ?? browserZone(),
          zoneChosen: preferences.timezone !== null,
        },
      };
    },
    staleTime: 60_000,
  });
